import { render, staticRenderFns } from "./recommend_product.vue?vue&type=template&id=544505ef&scoped=true"
import script from "./recommend_product.vue?vue&type=script&lang=js"
export * from "./recommend_product.vue?vue&type=script&lang=js"
import style0 from "./recommend_product.vue?vue&type=style&index=0&id=544505ef&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544505ef",
  null
  
)

export default component.exports